import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Input, Row, Spin } from 'antd';
import axios from 'axios';
import { axiosErrorHandler } from '../../../../swzutils';
import { isUserMultiTenant } from '../../../../swzutils/UserPermissionsUtil';
import SenderReceiverSelect from '../../components/SenderReceiverSelect';
import { EditMode } from "../../enums/EditMode";
import { useNavigate } from "react-router-dom";
import RequireTenantSelection from "../../components/RequireTenantSelection";
import { useAppSelector } from "../../../../store";
import { loggedInUserSelector, selectedTenantSelector } from "../../../../store/slice/auth";
const DivisionForm = ({ mode, divisionId }) => {
    const [form] = Form.useForm();
    const loggedInUser = useAppSelector(loggedInUserSelector);
    const selectedTenant = useAppSelector(selectedTenantSelector);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [editDivision, setEditDivision] = useState(undefined);
    useEffect(() => {
        if (mode == EditMode.EDIT && divisionId) {
            loadDivision();
        }
    }, [mode, divisionId]);
    const loadDivision = () => {
        axios.get(`/admin/v1/divisions/${divisionId}`)
            .then(response => {
            const division = response.data;
            form.setFieldsValue({
                "code": division.code,
                "name": division.name,
                "defaultSender": division.defaultSenderId
            });
            if (isUserMultiTenant(loggedInUser)) {
                form.setFieldsValue({
                    "tenantId": division.tenantId
                });
            }
            setEditDivision(division);
        })
            .catch(axiosErrorHandler)
            .finally(() => setLoading(false));
    };
    const save = (formValues) => {
        let saveUri = '/admin/v1/divisions/';
        let saveMethod = "post";
        let tenantId = selectedTenant?.id;
        if (mode == EditMode.EDIT && divisionId) {
            tenantId = editDivision?.tenantId;
            saveUri += divisionId;
            saveMethod = "put";
        }
        setLoading(true);
        axios(saveUri, {
            method: saveMethod,
            data: {
                tenantId: tenantId,
                code: formValues.code,
                name: formValues.name,
                defaultSenderId: formValues.defaultSender
            }
        })
            .then(( /*response*/) => backToList())
            .catch(axiosErrorHandler)
            .finally(() => setLoading(false));
    };
    const backToList = () => {
        navigate('/app/divisions/list');
    };
    const tenantId = (editDivision && editDivision.tenantId) ? editDivision.tenantId : selectedTenant?.id;
    if (!tenantId) {
        return (_jsx(RequireTenantSelection, {}));
    }
    return (_jsx(Spin, { spinning: loading, children: _jsxs(Form, { layout: "vertical", onFinish: save, form: form, children: [_jsxs(Card, { title: "Division Details", type: "inner", variant: 'borderless', children: [_jsx(Form.Item, { name: "code", label: "Code", rules: [
                                { required: true, message: 'Please enter a unique code.' },
                                { pattern: /^[0-9a-z\-_]+$/i, message: 'The code should only contain letters, numbers (-) hyphen and (_) underscore' },
                                { max: 20, message: 'Please limit the name to 20 characters.' }
                            ], children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "name", label: "Name", rules: [
                                { required: true, message: 'Please input a name.' }
                            ], children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "defaultSender", label: "Default Sender", valuePropName: "senderReceiverId", children: _jsx(SenderReceiverSelect, { tenantId: tenantId }) })] }), _jsxs(Row, { gutter: 10, className: "no-margin", children: [_jsx(Col, { xs: 12, sm: 4, children: _jsx(Button, { htmlType: "submit", block: true, type: "primary", size: "large", children: "Save" }) }), _jsx(Col, { xs: 12, sm: 4, children: _jsx(Button, { htmlType: "button", block: true, type: "default", onClick: backToList, size: "large", children: "Cancel" }) })] }), _jsx("p", { children: "\u00A0" })] }) }));
};
export default DivisionForm;
